import React from 'react'
import { Form, Input } from 'antd'
import AceEditor from 'react-ace'

import 'brace/mode/json'
import 'brace/theme/xcode'

import CompileTemplateIcon from '../../../../../../reusables/components/compile-template-icon'
import MemoryStore from '../../../../../../utils/memory-store'

class LDAPRouteAddEntry extends React.Component {
  constructor(props) {
    super(props)

    this.entry = MemoryStore.activeEntries[this.props.tabKey]

    this.state = {
      entry: props.entry.routeData,
      dnEntry: props.entry.routeData.entry || '',
      controls: props.entry.routeData.controls || ''
    }

    // Bindings
    this.onFieldChange = this.onFieldChange.bind(this)
  }

  onFieldChange (key, value) {
    this.entry.custom.isModifiedSubform = true
    this.props.entry.routeData[key] = value.trim()
  }

  render () {
    return (
      <div>
        <Form.Item>
          <span style={{ color: 'red' }}>* </span>
          {'DN '}
          <CompileTemplateIcon />
          <Input
            name='dn'
            placeholder='Distinguished name'
            disabled={this.props.disabled}
            defaultValue={this.state.entry.dn}
            onChange={e => {
              this.onFieldChange('dn', e.target.value)
            }}
          />
        </Form.Item>
        <Form.Item>
          <h3><span style={{ color: 'red' }}>* </span>Entry <CompileTemplateIcon /></h3>
          <AceEditor
            showPrintMargin={false}
            readOnly={MemoryStore.userProfile.teamPrivileges.connectors === 'Reader'}
            cursorStart={1}
            mode='json'
            theme='xcode'
            style={{ width: '100%', height: 300 }}
            name='aceEditor'
            value={this.state.dnEntry}
            setOptions={{
              showLineNumbers: true,
              newLineMode: 'unix'
            }}
            onChange={value => {
              this.onFieldChange('entry', value)
              this.setState({ dnEntry: value })
            }}
          />
        </Form.Item>
        <Form.Item>
          <h3>Controls <CompileTemplateIcon /></h3>
          <AceEditor
            showPrintMargin={false}
            readOnly={MemoryStore.userProfile.teamPrivileges.connectors === 'Reader'}
            cursorStart={1}
            mode='json'
            theme='xcode'
            style={{ width: '100%', height: 300 }}
            name='aceEditor'
            value={this.state.controls}
            setOptions={{
              showLineNumbers: true,
              newLineMode: 'unix'
            }}
            onChange={value => {
              this.onFieldChange('controls', value)
              this.setState({ controls: value })
            }}
          />
        </Form.Item>
      </div>
    )
  }
}

export default LDAPRouteAddEntry
